import { c as _c } from "react/compiler-runtime";
import { JsonLd } from 'react-schemaorg';
import type Schema from 'schema-dts';
import { webBaseUrl } from '@/settings';
type BreadcrumbItem = {
  name: string;
  url: string;
};
type Props = {
  breadcrumbList: BreadcrumbItem[];
};
export const BreadcrumbList = t0 => {
  const $ = _c(4);
  const {
    breadcrumbList
  } = t0;
  if (!breadcrumbList?.length) {
    return null;
  }
  let t1;
  let t2;
  if ($[0] !== breadcrumbList) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const validItems = breadcrumbList.filter(_temp);
      if (!validItems.length) {
        t2 = null;
        break bb0;
      }
      let t3;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
          "@type": "ListItem",
          position: 1,
          item: {
            "@type": "WebPage",
            "@id": `${webBaseUrl}/`,
            name: "Home"
          }
        };
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [t3, ...validItems.map(_temp2)]
      };
      t1 = <JsonLd item={breadcrumbSchema} />;
    }
    $[0] = breadcrumbList;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  return t1;
};
function _temp(item) {
  return item?.name?.trim() && item?.url?.trim();
}
function _temp2(item_0, index) {
  return {
    "@type": "ListItem",
    position: index + 2,
    item: {
      "@type": "WebPage",
      "@id": webBaseUrl + (item_0.url.startsWith("/") ? item_0.url : `/${item_0.url}`),
      name: item_0.name.trim()
    }
  } as Schema.ListItem;
}